// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { color } from "@synd/XDL/Utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

// <XNG-Change> - Adding a color picker & overrideTitle.
const enum fields {
    textColor = "textColor",
    overrideTitle = "overrideTitle",
    showBorderBottom = "showBorderBottom",
}
// </XNG-Change>
export interface PageTitleStyles {
    titleText?: TypographyPresentationProps;
}

export const pageTitleStyle: PageTitleStyles = {
    titleText: {
        css: css`
            ${({ showBorderBottom }: any) =>
                showBorderBottom &&
                css`
                    padding-bottom: 12px;
                    border-bottom: 1px solid ${color("common.border")};
                `}
        `,
    },
};

const styles = pageTitleStyle;

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

// XNG-Changes: Change variant to h1 ,adding a color and style
const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <Typography
        variant="h1"
        as="h1"
        color={fields.textColor}
        data-test-selector="PageTitle"
        {...{ showBorderBottom: fields.showBorderBottom }}
        {...styles.titleText}
    >
        {fields.overrideTitle || pageTitle}
    </Typography>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                name: fields.textColor,
                displayName: "Text color",
                editorTemplate: "ColorPickerField",
                defaultValue: "black",
                fieldType: "General",
            },
            {
                name: fields.overrideTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.showBorderBottom,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
